import { render, staticRenderFns } from "./UserOrderRejected.vue?vue&type=template&id=a2048938&"
import script from "./UserOrderRejected.vue?vue&type=script&lang=js&"
export * from "./UserOrderRejected.vue?vue&type=script&lang=js&"
import style0 from "./css/common.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports